// Generated by ts-to-zod
import { z } from 'zod';

export const paginationResponseSchema = z.object({
  next: z.string().nullable(),
  previous: z.string().nullable(),
  total: z.number(),
  totalPages: z.number(),
});
